import React from "react";
import NavigationItem from "./NavigationItem";
import { NAVIGATION_DEMO } from "data/navigation";
import { useSelector } from "react-redux";

function Navigation() {
  const isAdmin = useSelector((state) => state?.auth?.isAdmin);
  return (
    <ul className="nc-Navigation hidden lg:flex lg:flex-wrap lg:items-center lg:space-x-1 relative">
      {NAVIGATION_DEMO.filter((item) => {
        if (isAdmin) {
          return true;
        } else {
          return !item.isAdmin;
        }
      }).map((item) => (
        <NavigationItem key={item.id} menuItem={item} />
      ))}
    </ul>
  );
}

export default Navigation;
